import store from 'src/js/store';
import user from 'yola-editor/src/js/modules/user';
import references from '../constants/references';

const getTranslateCustomCodeTutorialUrl = () => {
  const state = store.getState();
  const isWhiteLabel = user.selectors.getWhiteLabelStatus(state);

  return isWhiteLabel
    ? references.TRANSLATE_CUSTOM_CODE_TUTORIAL_WL_URL
    : references.TRANSLATE_CUSTOM_CODE_TUTORIAL_URL;
};

export default getTranslateCustomCodeTutorialUrl;
